import { render } from "./marqueTemplate.vue?vue&type=template&id=55e3e4cc&scoped=true"
import script from "./marqueTemplate.vue?vue&type=script&lang=js"
export * from "./marqueTemplate.vue?vue&type=script&lang=js"

import "./marqueTemplate.vue?vue&type=style&index=0&id=55e3e4cc&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e3e4cc"]])

export default __exports__